// extracted by mini-css-extract-plugin
export default {"basket":"Basket_basket__R4fuM","basketCount":"Basket_basketCount__Kild+"};